@if (tabs().length) {
  <nav class="navigation-tabs" aria-label="Section navigation">
    @for (tab of tabs(); track tab.route + tab.label) {
      <a
        class="navigation-tabs__item"
        [routerLink]="tab.route"
        queryParamsHandling="preserve"
        routerLinkActive="navigation-tabs__item--active"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        [attr.aria-current]="rla.isActive ? 'page' : null"
        (click)="selectTab(tab)"
      >
        @if (tab.svgIcon) {
          <ocp-themed-icon class="navigation-tabs__icon" [name]="tab.svgIcon" />
        } @else if (tab.badge) {
          <ocp-avatar [userInitials]="tab.badge" size="sm" singleInitial />
        } @else if (tab.icon) {
          <span class="navigation-tabs__icon" [class]="tab.icon" aria-hidden="true"></span>
        }
        <span class="navigation-tabs__label">{{ tab.label | translate }}</span>
      </a>
    }
  </nav>
}
